import { AbstractSearchCriteria } from './abstract-search-criteria';

export class LanguageSearchCriteria extends AbstractSearchCriteria {
    code: string = '';
    name: string = '';
}
